import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { GlobalNotificationType } from '../Models/GlobalNotificationType';

@Injectable()
export class GlobalNotificationService {
    private _http = inject(HttpClient);
    private translate = inject(TranslateService);
    private _claims = inject<any>('Claims' as any);

    private serviceUrl: string = this._claims.baseUrl + 'breeze/Setting/';

    private _typeOptions: any[] = [
        {
            id: 0,
            name: this.translate.instant('Error'),
            imgSrc: '../../Content/icons/high-priority.png',
        },
        {
            id: 1,
            name: this.translate.instant('Warning'),
            imgSrc: '../../Content/icons/warning-icon.png',
        },
        {
            id: 2,
            name: this.translate.instant('Hint'),
            imgSrc: '../../Content/icons/hint.png',
        },
    ];

    get typeOptions(): any[] {
        return this._typeOptions;
    }

    public getIcon(type: number) {
        const match = this._typeOptions.find((o) => o.id == type);
        return match ? match.imgSrc : '';
    }

    public getNotification() {
        return this._http
            .get<any>(this.serviceUrl + 'GetGlobalNotification')
            .pipe(
                map((notification) => {
                    if (notification == null) return notification;

                    // SM2's Breeze serialization emits enums as strings ("Error"); normalize to the numeric enum value.
                    if (typeof notification.Type === 'string') {
                        notification.Type =
                            GlobalNotificationType[
                                notification.Type as keyof typeof GlobalNotificationType
                            ];
                    }

                    notification['Dismissed'] =
                        sessionStorage.getItem('HideGlobalNotification') ==
                        'true';

                    return notification;
                }),
            );
    }

    public dismissNotification() {
        sessionStorage.setItem('HideGlobalNotification', 'true');
        window.parent.postMessage(['setHeight', 0], '*');
    }

    public allowDisplayNotification() {
        sessionStorage.removeItem('HideGlobalNotification');
    }
}
